// Service for enriched hotel API calls (Exigence 6.7)
import { API_BASE_URL } from '../config/apiConfig';
import { HotelEnriched } from '../types/hotelEnriched';

function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };
}

export const hotelEnrichedService = {
  // Note: hotelId is extracted from JWT token by the API Gateway
  async getEnriched(_hotelId: string): Promise<HotelEnriched> {
    const response = await fetch(`${API_BASE_URL}/hotel/enriched`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Erreur lors du chargement de la fiche hôtel');
    return response.json();
  },

  async updateEnriched(_hotelId: string, data: HotelEnriched): Promise<HotelEnriched> {
    const response = await fetch(`${API_BASE_URL}/hotel/enriched`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || 'Erreur lors de la mise à jour de la fiche hôtel');
    }
    const result = await response.json();
    return result.hotel || result;
  },

  async listHotels(): Promise<HotelEnriched[]> {
    const response = await fetch(`${API_BASE_URL}/hotels`, {
      headers: getAuthHeaders(),
    });
    if (!response.ok) throw new Error('Erreur lors du chargement des hôtels');
    const data = await response.json();
    return data.hotels || data || [];
  },
};
